export default "__VITE_ASSET__cTyZ3Rwo__"